import { Alert, Button, DialogContent, DialogContentText, Tooltip } from "@mui/material";
import GenericTable from "common/components/GenericTable/GenericTable";
import { ApiService } from "common/services/ApiService";
import React from "react";

const DialogEstablishmentListComponent = ({ selectedUser, handleChangeExternalData }) => {
    const establishmentList = (selectedUser.role_establishment_list || []).map(
        (e) => e.establishment
    );

    const columns = [
            {
                field: "name",
                headerName: "Establecimiento",
                width: 300,
                disableColumnMenu: true,
                renderCell: (params) => {
                    return (
                        <Tooltip
                            enterTouchDelay={0}
                            leaveTouchDelay={15000}
                            disableTouchListener={false}
                            title={params.row.name}
                        >
                            <p
                                style={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                }}
                            >
                                {params.row.name}
                            </p>
                        </Tooltip>
                    );
                },
            },
            {
                field: "province",
                headerName: "Provincia",
                width: 300,
                disableColumnMenu: true,
            },
            {
                field: "location",
                headerName: "Localidad",
                width: 300,
                disableColumnMenu: true,
            }
        ];

    return (
        <>
            <DialogContent>
                <DialogContentText>
                    <strong>Nombre:</strong> {selectedUser.first_name} {selectedUser.last_name}
                </DialogContentText>
                <DialogContentText>
                    <strong>Email:</strong> {selectedUser.email}
                </DialogContentText>
                <DialogContentText>
                    <strong>DNI:</strong> {selectedUser.dni}
                </DialogContentText>
                <GenericTable
                    rows={establishmentList}
                    columns={columns}
                    disableSelectionOnClick
                    rowHeight={62}
                />
            </DialogContent>
        </>
    );
};

export default DialogEstablishmentListComponent;
